import { UserBasic } from '@hefe/models';
import {
  createAsyncThunk,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import API from '../../../api/api';

const FEATURE_KEY = 'basketballCoaches';

/************************************************************************************
 *
 *                                  ACTIONS
 *
 ************************************************************************************
 */
export const fetchBasketballCoaches = createAsyncThunk(
  'basketballCoaches/getAll',
  async (thunkAPI) => {
    const response = await API.basketballUsers().coaches();
    return response?.data;
  }
);

export const fetchBasketballCoachesConflicts = createAsyncThunk(
  'basketballCoaches/getAllConflicts',
  async (thunkAPI) => {
    const response = await API.basketballUsers().coachesConflicts();
    return response?.data;
  }
);

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface BasketballCoachesState {
  coaches: UserBasic[];
  conflicts: UserBasic[];
}

const initialState: BasketballCoachesState = {
  coaches: [],
  conflicts: [],
};

export const basketballCoachesSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchBasketballCoaches.fulfilled,
      (state: BasketballCoachesState, action: PayloadAction<UserBasic[]>) => {
        state.coaches = action.payload;
      }
    );
    builder.addCase(
      fetchBasketballCoachesConflicts.fulfilled,
      (state: BasketballCoachesState, action: PayloadAction<UserBasic[]>) => {
        state.conflicts = action.payload;
      }
    );
  },
});

/*
 * Export reducer for store configuration.
 */
export const basketballCoachesReducer = basketballCoachesSlice.reducer;
export const basketballCoachesActions = basketballCoachesSlice.actions;

const state = (rootState: any): BasketballCoachesState =>
  rootState[FEATURE_KEY];

export const basketballCoachesSelectSelector = createSelector(
  state,
  (state) => {
    return state.coaches.map((coach) => {
      return {
        value: coach.id,
        label: `${coach.firstname} ${coach.lastname}`,
      };
    });
  }
);
